import { IWorkTime } from '../types/developer/contacts';

export function getWorkTime(workTime?: IWorkTime | null) {
  if (!workTime) {
    return null;
  }

  return `${workTime.days}: c ${workTime.hoursFrom} до ${workTime.hoursTo}`;
}
